// prettier-ignore
class Minicart extends HTMLElement {
  constructor() {
    super();

    this.init.call(this);
    /**
     * state management, to easily re-render on every cart object update.
     */
    this.state = new Proxy({}, {
      get: (target, name) => target[name],
      set: (obj, prop, value) => {
        if (prop !== 'cartData') return false;
        obj[prop] = value;
        this.render();
        return true;
      }
    });

    this.setupEventListeners();
  }
  init(){
     this.minicartElement = this.querySelector('#minicart');
    this.actionElement = this.querySelector('#minicart-button-action');
    this.linkElement = this.querySelector('#cart-icon-bubble');
    this.panelElement = this.querySelector('#minicart-panel');
    this.overlayElement = this.querySelector('#minicart-overlay');
    this.cartQuantityElement = this.querySelector('#minicart-title-count');
    this.closeButtonElement = this.querySelector('#minicart-button-close');
    this.itemsListElement = this.querySelector('#minicart-items');
    this.subtotalElement = this.querySelectorAll('#minicart-subtotal');
    this.itemsTotalElement = this.querySelector('#minicart-items-total');
    this.discountElement = this.querySelector('#minicart-discount');
    this.treeItemTemplate = this.querySelector('#minicart-item-tree-template');
    this.minicartCheckoutButtons = this.querySelectorAll('.minicart__checkout-button');
    this.countriesToChangeCurrency = [ 'mx', 'ca', 'au' ];
    this.currentCountry = Shopify.country.toLowerCase();
    this.discountPrivateElement = this.querySelector('#minicart-discount-private');

    this.isoCode = this.countriesToChangeCurrency.includes(this.currentCountry)
      ? window.currency.isoCode + ' '
      : '';

    this.isOpen = false;
    this.lastFocus = undefined;

  }
  setCartData = (data) => {
    Promise
      .allSettled(data.items.map(async item => {
        const {tags, compareAtPrice, available} = await this.getItemDetail(item.handle, item.variant_id);
        return { ...item, compareAtPrice, tags, available }
      }))
      .then(newItems => {
        newItems.sort((a, b) => {
          if (a.value.available && !b.value.available) {
            return 1;
          }
          if (!a.value.available && b.value.available) {
            return -1;
          }
          return 0;
        });

        let newTotalPrice = data.total_price;
        newItems.forEach(item => {
          if(!item.value.available) newTotalPrice = newTotalPrice - item.value.price;
        })

        const newData = {
          ...data,
          items: newItems.map(item => item.value),
          total_price: newTotalPrice
        };
        this.state.cartData = newData;
        this.insertTreeToCart(data.item_count);
      })
      .catch(error => console.error('error:', error));
  }

  setupEventListeners = () => {
    if(this.linkElement){
      if(window.location.pathname.includes('/cart')) return;
      this.linkElement.addEventListener('click', this.open);
      this.linkElement.addEventListener('ontouchstart', this.open);
    }

    if(this.closeButtonElement){
      this.closeButtonElement.addEventListener('click', this.close);
      this.closeButtonElement.addEventListener('ontouchstart', this.close);
    }

    if(this.overlayElement){
      this.overlayElement.addEventListener('click', this.close);
      this.overlayElement.addEventListener('ontouchstart', this.close);
    }

    if(this.itemsListElement){
      this.itemsListElement.addEventListener('click', this.removeItem);
      this.itemsListElement.addEventListener('click', this.updateItem);
    }

    document.addEventListener('cartUpdate',async (event) => {

      let cartHtml = await fetch(window.Shopify.routes.root + "?sections=header").then(res => res.json());
      this.updateCartHTML.call(this,cartHtml['header']);
    });

    window.addEventListener('resize', this.resizePanel);
    this.insertTreeToCart(+this.cartQuantityElement.innerHTML);

  }

  resizePanel = () => {
    if(!this || !this.panelElement) return;
    const innerHeight = window.innerHeight;
    if(innerHeight < 1024){
      this.panelElement.style.height = innerHeight + "px";
    } else {
      this.panelElement.style.height = "";
    }
  }

  open = (event) => {
    try {
      event.stopPropagation();
      event.preventDefault();
      document.querySelector('sticky-header').reveal();

      this.minicartElement.setAttribute('open', '');
      this.actionElement.setAttribute('aria-expanded', 'false');
      this.panelElement.setAttribute('tabindex', '0');
      this.panelElement.setAttribute('open', '');
      this.panelElement.focus();

      document.body.classList.add('overflow-hidden');
      document.addEventListener('focus', this.restrictFocus, true);
      document.addEventListener('keydown', this.close);

      this.resizePanel();

      this.isOpen = true;
      this.lastFocus = document.activeElement;

      this.insertTreeToCart(+this.cartQuantityElement.innerHTML);
    } catch (error) {
      console.error(error);
      window.location = this.linkElement.href;
    }
  }

  close = (event) => {
    try {
      if (event.type === 'click') {
        event.stopPropagation();
        event.preventDefault();
      }

      /**
       * make sure to only do something if it's a click
       * on the close button, or after pressing Esc key.
       */
      if (
        event.type === 'click'
        || (
          event.type === 'keydown'
          && (event.key === 'Escape' || event.keyCode === 27)
        )
      ) {
        this.minicartElement.removeAttribute('open');
        this.actionElement.setAttribute('aria-expanded', 'false');
        this.panelElement.setAttribute('tabindex', '-1');
        this.panelElement.removeAttribute('open');

        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('focus', this.restrictFocus, true);
        document.removeEventListener('keydown', this.close);

        this.isOpen = false;
        this.lastFocus.focus();
      }
    } catch (error) {
      console.error(error);
    }
  }

  restrictFocus = (event) => {
    try {
      if (this.isOpen && !this.panelElement.contains(event.target)) {
        event.stopPropagation();
        this.panelElement.focus();
      }
    } catch (error) {
      console.error(error);
    }
  }

  updateItem = (event) => {
    try {
      if (event.target.matches('.js-update-item-quantity')) {
        event.stopPropagation();

        const quantity = +event.target.dataset.quantity;
        const line = +event.target.dataset.line;
        const action = event.target.dataset.action;
        const handleQuantity = {
          plus: quantity + 1,
          minus: quantity - 1
        }

        fetch(`${window.routes.root_url}/cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line,
            quantity: handleQuantity[action],
            sections:['header']
          })
        })
          .then((response) => {
            if (!response.ok) throw Error;
            return response.json();
          })
          .then((data) => {
            // this.setCartData(data);
            this.updateCartHTML.call(this,data.sections['header']);
            document.dispatchEvent(new Event('cartChanged'));
          })
          .catch((error) => {
            console.error(error);
          });
      }
    } catch (error) {
      console.error(error);
    }
  }

  removeItem = (event) => {
    try {
      if (event.target.matches('.js-remove-item-from-cart')) {
        event.stopPropagation();

        const line = +event.target.dataset.line;
        let item;

        fetch(`${window.routes.root_url}/cart.js`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw Error;
            return response.json();
          })
          .then((data) => {
            item = data.items[line - 1];

            return fetch(`${window.routes.root_url}/cart/change.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                line,
                quantity: 0,
                sections:['header']
              })
            });
          })
          .then((response) => {
            if (!response.ok) throw Error;
            return response.json();
          })
          .then((data) => {
            // this.setCartData(data);
            this.updateCartHTML.call(this,data.sections['header']);
            document.dispatchEvent(new Event('cartChanged'));

            if (window.FarmRio.events.removeFromCart) {
              const name = item.product_title.toLowerCase();
              let brand = 'farm';

              switch (name) {
                case ~name.indexOf('adidas'):
                  brand = 'adidas';
                  break;
                case ~name.indexOf('havaianas'):
                  brand = 'havaianas';
                  break;
                case ~name.indexOf("levi's"):
                  brand = "levis";
                  break;
                default:
                  break;
              }

              const eventName = window.FarmRio.events.removeFromCart;
              const event = new CustomEvent(eventName, {detail: [
                {
                  name,
                  brand,
                  sku: `${ item.variant_id }`,
                  id: `${ item.product_id }`,
                  quantity: item.quantity,
                  price: item.original_price / 100,
                  salesPrice: item.final_price / 100,
                  category: item.product_type.toLowerCase(),
                  variant: item.variant_options[1].toLowerCase(),
                }
              ]});
              document.dispatchEvent(event);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    } catch (error) {
      console.error(error);
    }
  }
  updateCartHTML(sectionData){
    let parser = new DOMParser();
    let html = parser.parseFromString(sectionData,"text/html");
    let cartHtml = html.querySelector('.minicart__box')?.innerHTML;
    this.querySelector('.minicart__box').innerHTML = cartHtml;
     const countBubbleElement = document.querySelector('.cart-count-bubble');
     countBubbleElement.innerHTML = html.querySelector("#minicart-title-count")?.innerHTML;
     if(countBubbleElement?.innerHTML){
      if(Number(countBubbleElement.innerHTML) > 0){
        countBubbleElement.classList.remove("cart-count-bubble--no-items")
      }else{
        countBubbleElement.classList.add("cart-count-bubble--no-items");
      }
     } 
    this.init.call(this);
    this.setupEventListeners.call(this);
  }
  /**
   * @param {string} imageUrl
   * @param {string|number} size
   */
  resizeImage = (imageUrl, size) => {
    try {
      if (!imageUrl || typeof imageUrl !== 'string') {
        throw new TypeError('"imageUrl" must be a string.');
      }

      if (!size) return imageUrl;

      if (typeof size !== 'string' && typeof size !== 'number') {
        throw new TypeError('If set, "size" must be a string or a number.');
      }

      const match = imageUrl.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match) {
        const prefix = imageUrl.split(match[0]);
        const suffix = match[0];

        return `${prefix[0]}_${size + (typeof size === 'number' ? 'x' : '')}${suffix}`;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
    }
  }

  money(obj) {
    return `${window.currency.symbol}${obj.value}`
  }

  render = () => {
    const countBubbleElement = document.querySelector('.cart-count-bubble');
    const itemsQuantity = this.state.cartData.item_count;

    // countBubbleElement.firstElementChild.innerHTML = itemsQuantity;
    countBubbleElement.querySelector(".cart-count-bubble-count").innerHTML =
    itemsQuantity;

    if (countBubbleElement) {
      countBubbleElement.firstElementChild.innerHTML = itemsQuantity;

      if (itemsQuantity > 0) {
        countBubbleElement.classList.remove("cart-count-bubble--no-items");
      } else {
        countBubbleElement.classList.add("cart-count-bubble--no-items");
      }
    }

    try {

      if (itemsQuantity === 0) {
        this.itemsListElement.innerHTML = this.getEmptyMarkup();
        this.itemsListElement.classList.add('is-empty');
      } else {
        this.itemsListElement.innerHTML = this.state.cartData.items
          .map((item, index) => {
            const _item = {
              ...item,
              currency: this.state.cartData.currency
            }
            return this.getItemMarkup(_item, index)
          })
          .join('');
        this.itemsListElement.classList.remove('is-empty');
      }

      this.cartQuantityElement.innerHTML = itemsQuantity;

      const subtotalPrice = this.state.cartData.items.reduce((result, item) => {
        if (item.available) {
          const privateSaleTag = item.tags.find(tag => tag.includes('private_sale_off:'));
          const isPrivateSale = sessionStorage.getItem('PrivateSale') && privateSaleTag;
      
          if (isPrivateSale) {
            const discountPercentage = Number(privateSaleTag.split(':')[1]);
            const fullPrice = item.price;
            const discountedPrice = fullPrice * (100 - discountPercentage) / 100;      
            return result + discountedPrice * item.quantity;
          } else {
            return result + item.price * item.quantity;
          }
        }
      
        return result;
      }, 0);

      const price = this.money({
        value: subtotalPrice / 100,
        currency: this.state.cartData.currency
      });

      this.subtotalElement.forEach(element => element.innerHTML = this.isoCode + price)     

      const itemsTotal = this.state.cartData.items.reduce(
        (result, item) => {
          if(item.available){
            const { price, compareAtPrice } = item;
            return (result + Math.max(price, compareAtPrice) * item.quantity);
          }
          return result
        },
        0
      );

      if (this.state.cartData.total_price === itemsTotal) {
        this.itemsTotalElement.parentNode.classList.add('hidden');
        this.discountElement.parentNode.classList.add('hidden');
        return;
      }

      this.itemsTotalElement.parentNode.classList.remove('hidden');
      this.discountElement.parentNode.classList.remove('hidden');

      const itemsTotalPrice = this.money({
        value: itemsTotal / 100,
        currency: this.state.cartData.currency
      });

      this.itemsTotalElement.innerHTML = this.isoCode + itemsTotalPrice;

      const discount = this.money({
        value: (itemsTotal - subtotalPrice) / 100,
        currency: this.state.cartData.currency
      });

      this.discountElement.innerHTML = '-' + this.isoCode + discount;
      this.discountPrivateElement.innerHTML = '-' + this.isoCode + discount;
    } catch (error) {
      console.error(error);
    }
  }

  getEmptyMarkup = () => `
    <li class="minicart__empty">
      <span class="minicart__empty-text">
        You don't have any items in your bag.
      </span>

      <a href="/collections/all" class="minicart__empty-link button button--primary button--full-width" aria-label="Shop now">
        Shop
      </a>
    </li>
  `

  getItemMarkup = (item, index) => {
    const imageSizes = [200, 500, 800, 1000];
    const privateSaleTag = item.tags.find( tag => tag.includes('private_sale_off:'));
    const isPrivateSale = sessionStorage.getItem('PrivateSale') && privateSaleTag
    const itemFullPrice = item.price;
    const itemPrivateSaleValue = isPrivateSale && (itemFullPrice * (100 - Number(privateSaleTag.split(':')[1])) / 10000).toFixed(2)
    const price = this.money({
      value: isPrivateSale ? itemPrivateSaleValue : item.final_price / 100,
      currency: item.currency
    });

    const compareAtPrice = this.money({
      value: isPrivateSale ? item.price / 100 : item.compareAtPrice / 100,
      currency: item.currency
    });

    const isGiftCard = item.product_type === "Gift Card";

    return `
      <li id="${ item.key }" class="minicart-item ${!item.available ? 'error' : ''}">
        <div class="minicart-item__image-wrapper">
          <a href="${ item.url }" class="minicart-item__image-link" aria-label="Go to ${ item.title } page">
            <img
              src="${ this.resizeImage(item.image, 200) }"
              srcset="${
                imageSizes
                  .map((size) => this.resizeImage(item.image, size))
                  .join(', ')
              }"
              sizes="(min-width: 600px) 200px, 50vw"
              alt="Image of ${ item.title }"
              class="minicart-item__image"
              width="200"
              height="${ Math.ceil(200 / item.featured_image.aspect_ratio) }"
              loading="lazy"
            >
          </a>
        </div>

        <div class="minicart-item__content">
          <p class='minicart-item__unavaible-tag ${ item.available ? 'hidden' : '' }'>Out of stock</p>
          <h3 class="minicart-item__title">
            <a href="${ item.url }" class="minicart-item__link" aria-label="Go to ${ item.title } page">
              ${ item.product_title
                .split(' ')
                .map(word => word.toLowerCase())
                .filter(Boolean)
                .map(word => word[0].toUpperCase().concat(word.slice(1)))
                .join(' ') }
            </a>
          </h3>

            ${!isGiftCard ? `<h4 class="minicart-item__sku-name">
              ${ item.variant_title
                .replace('1/2', '½')
                .split(' ½')
                .join('½') }
            </h4>` : ''}

            <div class="${ !item.available ? 'hidden' : '' } price minicart-item__price ${ (typeof item.compareAtPrice === 'number' && item.compareAtPrice > item.final_price) || isPrivateSale ? 'price--on-sale' : '' }">
              <div>
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">
                    Regular price
                  </span>
                  <span class="price-item price-item--regular">
                    ${ this.isoCode + price }
                  </span>
                </div>
                <div class="price__sale">
                  <span class="visually-hidden visually-hidden--inline">
                    Regular price
                  </span>
                  <span>
                    <s class="price-item price-item--regular">
                      ${ this.isoCode + compareAtPrice }
                    </s>
                  </span>
                  <span class="visually-hidden visually-hidden--inline">
                    Sale price
                  </span>
                  <span class="price-item price-item--sale price-item--last">
                    ${ this.isoCode + price }
                  </span>
                </div>
              </div>
            </div>

            ${isGiftCard ? `
              <div class="minicart-gift_card_recipient_info">
                ${Boolean(item.properties["Recipient name"]) ? `<p><span>To: </span><span>${item.properties["Recipient name"]}</span></p>` : ""}
                ${Boolean(item.properties["Recipient email"]) ? `<p><span>Recipient Email: </span><span>${item.properties["Recipient email"]}</span></p>` : ""}
                ${Boolean(item.properties["Message"]) ? `<p><span>Message: </span><span>${item.properties["Message"].length > 30 ? item.properties["Message"].substring(0, 30) : item.properties["Message"]}...</span></p>` : ""}
                ${Boolean(item.properties["Send on"]) ? `<p><span>Send on: </span><span>${item.properties["Send on"]}</span></p>` : ""}
              </div>
            `: ""}

            <div class="minicart-item__controls">
              <div class="minicart-item__quantity">
                <button
                  class="minicart-item__quantity-button ${
                    item.quantity >= 2
                      ? 'js-update-item-quantity'
                      : 'js-remove-item-from-cart'
                  }"
                  type="button"
                  data-quantity="${ item.quantity }"
                  data-line="${ index + 1 }"
                  data-action="minus"
                  data-available="${!item.available ? 'false' : 'true'}"

                  aria-label="${
                    item.quantity >= 2
                      ? `Remove 1 ${ item.title } from your cart. You have ${ item.quantity } of it at the moment.`
                      : `Remove ${ item.title } from your cart.`
                  }"
                >
                  -
                </button>

                <input
                  type="tel"
                  name="quantity"
                  id="minicart-input-quantity"
                  class="minicart-item__quantity-input"
                  value="${ item.quantity }"
                  pattern="\d+"
                  size="2"
                  tabindex="-1"
                  readonly
                  data-available="${!item.available ? 'false' : 'true'}"
                />

                <button
                  class="minicart-item__quantity-button js-update-item-quantity"
                  type="button"
                  data-quantity="${ item.quantity }"
                  data-line="${ index + 1 }"
                  data-action="plus"
                  aria-label="Add 1 more ${ item.title } to your cart. You have ${ item.quantity } of it at the moment."
                  data-available="${item.available}"

                >
                  +
                </button>
              </div>

              <button
                class="minicart-item__remove js-remove-item-from-cart"
                type="button"
                aria-label="Remove ${ item.title } from cart."
                data-line="${ index + 1 }"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 8V19.0769C18 19.5846 17.62 20 17.14 20H6.86C6.39 20 6 19.5846 6 19.0769V8" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 6.03998H20" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15 4.04V3C15 2.45 14.55 2 14 2H10C9.45 2 9 2.45 9 3V4.04" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 10V17" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 10V17" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <p class='minicart-item__unavaible-text ${ item.available ? 'hidden' : '' }'>Please remove this item before proceeding to the checkout.</p>
        </div>
      </li>
    `;
  }

  getItemDetail = async (productSlug, variantId) => {
    const compareAtPrice = await fetch(
      `${window.routes.root_url}/products/${productSlug}.js`,
      { credentials: 'same-origin' }
    )
      .then(response => response.json())
      .then(data => {
        const correspondingVariant = data.variants.find(
              (variant) => variant.id === variantId
            );
       return {tags: data.tags, compareAtPrice: data.compare_at_price, available: correspondingVariant.available}
      })
      .catch((error) => {
        console.error(error);
        return 0;
      });
    return compareAtPrice;
  }

  insertTreeToCart = (itemsCount) => {
    // if (itemsCount <= 0) return;

    // const alreadyHasTreeItem = this.itemsListElement.querySelector('.minicart-item__tree');
    // if (alreadyHasTreeItem) return;

    // const treeItemElement = this.treeItemTemplate.content.cloneNode(true);
    // this.itemsListElement.appendChild(treeItemElement);
  }
}

customElements.define("minicart-panel", Minicart);
